<template>
    <div id="index">
        <div id="containerBox">
            <div id="header1">
                <div>
                    {{now1}}
                </div>
            </div>

            <div id="leftPart">
                <div id="content1">
                    <router-link to="/"><img src='/images/web_img/TOG_Logo_500X70_3.jpg' alt=""></router-link>
                    <img src='/images/web_img/book.gif' alt="">
                </div>

                <div id="content2">
                    <ul>
                        <li><router-link to="/renjiadao">Renjia Road</router-link></li>
                        <li><router-link to="/video">Share video</router-link></li>
                        <li><a href="/xuezhe.asp" target="_blank" rel="noopener noreferrer">Study rules</a></li> <!-- 学者会学规 -->
                        <li><router-link to="/useraddnew">Your sharing</router-link></li>
                        <li><a href="http://www.bolaaw.com/" target="_blank" rel="noopener noreferrer">About Us</a></li>
                    </ul>
                </div>

                <div id="content3">
                    <video src="/images/web_img/SHOUYE.mp4" autoplay loop muted playsinline></video>
                </div>

                <div style="width:1000px;height:400px;">
                    <p style="font-size:30px;font-weight:600;margin-top:30px;">Renjia Road</p>
                    <p style="width:690px;margin:30px auto;text-align:left;text-indent:2em;line-height:30px;">
                      <!-- 人家道工作坊，将给你一个多方位探索过程。在这里你将学习作为一个学者去深入探索和研究你想分享的话题，不带任何偏见，但却热诚、关注并去不停访问和深入研究，并且学习怎样去提问、回应，拍照更加深入了解研究的话题。同时，你会通过这个过程更加明白自己，对自己的世界观有更强的认识。你会学习到如何增强六大管理指标平衡，并回到修身管理目标的中心点。此外，在你将会参与的学者小组会议中，你有机会得到其他学者对你个人的指引，并且更深入探索及讨论自己突破研究模式的原则。对许多人而言，这个指引别人并被别人指引的机会是工作坊中最有价值的一部分。人家道工作坊要求你每天有30分钟的阅读，阅读范围是选自世界上伟大的哲学、历史、文学、心灵著作及发生在世界各地的新闻。另外，每月要交出一篇1千字以上的话题写作，记录你个人在这趟探索之旅程的进展，可刊登在www.templeofgood.com上、祝您探索旅途愉快！-->
                      The Renjia Road Workshop will provide you with a multi-faceted exploration process. Here, you will learn as a scholar to delve into and study the topics you want to share, without any bias, but with enthusiasm, attention, and continuous access and in-depth research. You will also learn how to ask questions, respond, and take photos to gain a deeper understanding of the research topic. At the same time, you will gain a better understanding of yourself and a stronger awareness of your worldview through this process. You will learn how to enhance the balance of the six management indicators and return to the central point of self-cultivation management goals. In addition, during the scholar group meetings you will participate in, you will have the opportunity to receive guidance from other scholars and explore and discuss in greater depth the principles of breaking through your research model. For many people, this opportunity to guide others and be guided by others is the most valuable part of the workshop. The Renjia Dao Workshop requires you to read for 30 minutes every day, covering great philosophical, historical, literary, and spiritual works from around the world, as well as news from around the world. In addition, you need to submit a topic writing of over 1000 words per month to record your personal progress on this exploration journey. It can be published on www.templeofgood.com. Wishing you a pleasant exploration journey!
                    </p>
                </div>


                <div id="content7">
                    <img src='/images/web_img/footer1.jpg' alt="">

                    <pageFooter></pageFooter>
                </div>
            </div>

            <div id="rightPart">

                <img src='/images/web_img/party-lg.jpg' alt="">
                <img src='/images/web_img/in-the-future.jpg' alt="">
                <img src='/images/web_img/earth.jpg' alt="">
            </div>
        </div>
    </div>
</template>

<!--<script src="http://www.templeofgood.com/TJ/sjmp5_LLFenxi.js" type="text/javascript" ></script> -->
<script>
import pageFooter from "@/components/Footer";
import clock from "@/mixins/clock";
import { request } from "@/api/http";

export default {
    components:{
        pageFooter,
    },

    mixins: [clock],

    data(){
        return{
            videourl: '',
        }
    },

    mounted(){
        this.getvideo();
    },
    methods: {
        getvideo(){
            request('/CalawaEnServlet/VideoServlet', { action: 'getPlayVideo' })
            .then(res=> {
                this.videourl = this.$store.state.WebURL + res.data.video;
            })
            .catch(error=> {
                console.log(error);
            });
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@mixin manyLine6{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
}

@mixin manyLine5{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
}

@mixin manyLine4{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
}

@mixin manyLine3{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}

#index{
    width: 100%;
    min-height: 1170px;
    height: 100%;

    a { text-decoration:none; }
    a:hover { text-decoration:none; cursor: pointer;}

    background-color: white;

    #containerBox{
        width: 1260px;
        min-height: 1170px;
        height:100%;

        background-color: #ccc;

        margin: 0 auto 0 auto;

        #header1{
            width: 1212px;
            height: 15px;

            padding:15px 11px 15px 11px;

            div{ float: left; }
        }

        #leftPart{
            width: 1000px;
            height: 1100px;

            float:left;
            margin: 0 6px 0 11px;
            // background-color: aqua;
            background-color: white;

            #content1{
                height: 71px;
                background-color: white;
                img{
                    float: left;
                }
            }

            #content2{
                width: 1000px;
                height: 43px;

                margin-top: 10px;
                ul{
                    width: 1000px;
                    height: 43px;
                    li{
                        width: 200px;
                        height: 43px;

                        float: left;

                        a{
                            width: 200px;
                            height: 33px;
                            display: inline-block;

                            background: url(../../assets/leftpart/content2/hongse.jpg) no-repeat center;
                            background-size: 200px 43px;
                            color: white;

                            padding-top: 10px;
                        }
                    }
                }
            }

            #content3{
                img{
                    margin-top: 10px;
                }
                video{
                    display: block;
                    width: 1000px;
                    margin-top: 10px;
                }
            }

            #content5{

                img{
                    margin: 10px 0 10px 0;
                }
            }

            #content7{
                width: 1000px;
                img{
                    width: 1000px;
                    margin-top: 10px;
                }
            }
        }

        #rightPart{
            width: 230px;
            height: 980px;

            float:left;

            background-color: white;

            img{
                width:220px;
                margin-top: 10px;
            }
            .fenxiang{
                width:220px;
                margin-top: -40px;
            }

            .contactus{
                width: 220px;
                height: 300px;
                margin-left: 5px;
                img:nth-child(1){
                    width: 220px;
                }
                p{
                    text-align: left;
                    font-size: 13px;
                    margin: 10px 10px 0 10px;
                }
                img:nth-child(7){
                    width: 100px;
                    position: relative;
                    right: -65px;
                    top: -70px;
                }
            }

        }
    }
}
</style>